import type {UserWDto} from '@cohort/wallet-schemas/user';
import type {User} from 'firebase/auth';
import {create} from 'zustand';

export type UserStore = {
  firebaseUser: User | null;
  initEmail?: string;
  isAuthenticating: boolean;
  isLoggedIn: boolean;
  user: UserWDto | null;
  login: (firebaseUser: User, user: UserWDto) => void;
  logout: () => void;
  setIsAuthenticating: (isAuthenticating: boolean) => void;
  setInitEmail: (email?: string) => void;
};

export const useUserStore = create<UserStore>(set => ({
  firebaseUser: null,
  isAuthenticating: true,
  isLoggedIn: false,
  user: null,
  login: (firebaseUser, user) =>
    set({
      isAuthenticating: false,
      isLoggedIn: true,
      firebaseUser,
      user,
    }),
  logout: () =>
    set({
      isAuthenticating: false,
      isLoggedIn: false,
      firebaseUser: null,
      user: null,
    }),
  setIsAuthenticating: isAuthenticating => set({isAuthenticating}),
  setInitEmail: email => set({initEmail: email}),
}));
